require('../vendor/jquery.zoom.min');

$('#product-media .item').fitVids();

if ($('#variants-data').length) {

	const variantData = JSON.parse($('#variants-data').text());
	const variantMeta = JSON.parse($('#variants-metafields-data').text());
	const shippingMessages = JSON.parse($('#shipping-messages-data').text());
	const $addToCartBtn = $('[name="add"]');
	const $selectedVariant = $('#selected-variant');
	const $summary = $('#product-form-summary');
	const delimiter = ' / ';
	const inputSelector = '.product-form-input';
	const partNumber = window.helpers.getUrlParameter('part-number');
	var possibleConfigurations = variantData.map(variant => {
		return variant.title
	});

	var haveGunId = false;
	var dynamicOptions = null;
	var dynamicVariants = null;
	var dynamicConfigurations = [];

	function getShippingData(key, get) {
		// if the variant's key is "default" then we read either the product's or collection's key as the fallback.
		if (key === 'default') {
			key = window.fallbackShippingMessageKey;
		}
		switch (get) {
			case 'message':
				return shippingMessages[key].message;
				break;

			case 'days':
				return shippingMessages[key].days;
				break;

			default:
				break;
		}
	}


	function populateMeta(variantId) {
		let data = [];
		let meta = [];

		if (dynamicVariants && window.useDynamicVariants) {
			let holsters = dynamicVariants.filter(variant => {
				return variant.product_id === variantId;
			});
			// make our own arrays to use below
			if (holsters.length) {
				data.push({
					"sku": holsters[0].product_id
				});
				meta.push({
					"part_number": holsters[0].legacy_part_number,
					"model": holsters[0].model,
					"quick_ship": holsters[0].quick_ship,
					"promotion": holsters[0].promotion,
					"last_chance": holsters[0].last_chance,
					"shipping_key": holsters[0].shipping_message || 'default'
				})
			}
		} else {
			// read the data dumped to the liquid template
			data = variantData.filter(variant => {
				return variant.id == variantId;
			});
			meta = variantMeta.filter(variant => {
				return variant.id == variantId;
			});
		}

		// bail if we don't find a variant (unlikely)
		if (!data.length || !meta.length) {
			disablePurchase();
			return;
		}

		let markup = '<dl class="variant-meta">';
		if (data[0].sku) markup += `<dt>SKU</dt><dd>${data[0].sku}</dd>`;
		if (meta[0].part_number) markup += `<dt>Part Number</dt><dd>${meta[0].part_number}</dd>`;
		if (meta[0].model) markup += `<dt>Model</dt><dd>${meta[0].model}</dd>`;
		markup += '</dl>';
		if (meta[0].shipping_key) markup += `<p class="product-message">${getShippingData(meta[0].shipping_key, 'message')}</p>`;
		$summary.html(markup);

		$('#itemprop-sku').val(data[0].sku);
		$('#itemprop-part').val(meta[0].part_number);
		$('#itemprop-model').val(meta[0].model);
		$('#itemprop-shipping').val(getShippingData(meta[0].shipping_key, 'message'));
		$('#itemprop-shipping-days').val(getShippingData(meta[0].shipping_key, 'days'));
		$('#itemprop-quickship').val(meta[0].quick_ship);
		$('#itemprop-promotion').val(meta[0].promotion);
		$('#itemprop-lastchance').val(meta[0].last_chance);

		$('.quick-ship-badge').hide();
		if (meta[0].quick_ship) {
			$('.quick-ship-badge').show();
		}

		if ($('#itemprop-options').length) {
			let selections = getFinderSelections();
			let options = [];
			let gunOptions = [];
			if (selections && selections.data.gun) {
				delete selections.data.gun.holsters;
				$('#itemprop-gun-data').val(JSON.stringify(selections.data));
				gunOptions.push(`Firearm:${selections.data.gun.manufacturer} ${selections.data.gun.model} (${selections.data.gun.barrel} Barrel Length, ${selections.data.gun.caliber} Caliber)`);
				if (selections.data.details.lightName) {
					gunOptions.push(`Light:${selections.data.details.lightName}`);
				}
				if (selections.data.details.opticName) {
					gunOptions.push(`Optic:${selections.data.details.opticName}`);
				}
				$('#itemprop-gun-options').val(gunOptions.join('|'));
			}
			$('.product-option').each(function () {
				let title = $(this).find('label').text().trim();
				let value = $(this).find('select').val();
				let valueLabel = $(this).find(`[value="${value}"]`).text();
				options.push(title + ':' + valueLabel);
			});

			let choices = options.join('|');
			$('#itemprop-options').val(choices);
		}

	}

	function getGroupMarkup(name, ui, i, handle) {
		let classes = ['product-form-input'];
		let option = `<option value="">Select ${name}&hellip;</option>`;
		if (ui === 'button') {
			classes.push('visually-hidden');
			option = '';
		}
		return `<div class="form-group product-option is-${ui}" data-option-index="${i}" data-option-handle="${handle}">
              <label class="label" for="option-${i}">${name}</label>
              <select id="option-${i}"
                class="${classes.join(' ')}"
                name="${name}"
              >
                ${option}
              </select>
            </div>`;
	}

	function getSwatchMarkup(classes, value, handle, target, mkImage) {
		return `<button class="${classes}"
              data-value="${handle}"
              data-for="#option-${target}"
              title="${value}"
              ${mkImage}
              >
              <span class="visually-hidden">${value}</span>
            </button>`;
	}

	function selectedConfiguration() {
		let a = [];
		$(inputSelector).each(function () {
			if ($(this).val()) {
				a.push($(this).val());
			}
		});
		return a.join(delimiter);
	}

	function disablePurchase() {
		$addToCartBtn.prop('disabled', true);
		$selectedVariant.val('');
		$summary.html('');
	}

	function enablePurchase() {
		let checkoutId = null;
		let metaId = null;
		if (window.useDynamicVariants) {
			// if we have neither a gun or a part number, we can't checkout
			if (!haveGunId && !partNumber) return;
			// default to using the lookup when we have a gun
      		// there will be one holster in variants with the particular configuration we've selected
			let selected = dynamicConfigurations.filter(config => {
				return config.configuration === selectedConfiguration()
			});
			// assuming we find one, find the shopify variant with the same title as the matched config's price
			if (selected.length > 0) {
				variantData.forEach(variant => {
					if (variant.title * 1 === selected[0].price) {
						checkoutId = variant.id; // regular shopify variant
						metaId = selected[0].id; // product ID from the finder
					}
				});
			}
			
			// if we don't have a gun, then our dynamic variants can have several option configurations with the same choices (multiple SKUs with Black/Right/STX Tactical, etc)
			// when that happens, the first dynamic variant that matches our pre-selected choices gets picked using the method above, which may not match the actual part number
			// so, ensure that we're matching on the part number to get the correct SKU, but only when we don't have the gun, otherwise the part number won't change
			if (partNumber && !haveGunId) {
				selected = dynamicVariants.filter(variant => {
					return (variant.legacy_part_number == partNumber);
				});
				// assuming we find a match, use the shopify variant with the same title as the dynamic variant's price and populate meta on its finder ID
				if (selected.length > 0) {
					variantData.forEach(variant => {
						if (variant.title * 1 === selected[0].price * 100) {
							checkoutId = variant.id; // regular shopify variant
							metaId = selected[0].product_id; // product ID from the finder
						}
					});
				}
			}
			
		} else {
			// for normal products, we can just find the selected configuration in the variant titles
			// the variant ID will be the same for checkout and for displaying meta info
			variantData.forEach(variant => {
				if (variant.title === selectedConfiguration()) {
					checkoutId = variant.id;
					metaId = variant.id;
				}
			});
		}

		// we have a match, can add to cart and display things
		if (checkoutId) {
			$addToCartBtn.prop('disabled', false);
			$selectedVariant.val(checkoutId);
			populateMeta(metaId);
		}
	}

	var selectOption = function ($group, value) {
		if ($group.find('.swatches').length) {
			$group.find(`[data-value="${window.helpers.makeHandle(value)}"]`).click();
		} else {
			$group.find('select.product-form-input').val(window.helpers.makeHandle(value)).trigger('change');
		}
	};

	function disableOptions($groups) {
		$groups.each(function () {
			let $select = $(this).find(inputSelector);
			$select.val('');
			$select.find('option').prop('disabled', true);
		});
	}

	function enableOptions($groups) {
		// reset downstream
		disableOptions($groups);
		disablePurchase();
		// enable options in the next group
		$groups.first().find('option').each(function () {
			// what would this configuration be
			let thisConfiguration = selectedConfiguration() + delimiter + $(this).val();
			// does this path exist in the variant titles?
			possibleConfigurations.forEach(c => {
				if (c.includes(thisConfiguration)) {
					$(this).prop('disabled', false);
				}
			});
		});
	}

	function getFinderSelections() {
		if (localStorage.getItem('holster_finder_selections')) {
			return JSON.parse(localStorage.getItem('holster_finder_selections'));
		}
		return false;
	}

	function getApiEndpoint() {
		let endpoint = window.apiHost + '/holsters/configurations/' + window.productHandle;
		let selections = getFinderSelections();
		// if we've visited the holster finder, only get the options for our gun
		if (selections) {
			if (selections.data && selections.data.gun) {
				haveGunId = true;
				endpoint += '/gun/' + selections.data.gun.id;
				if (selections.data.details !== null) {
					// optics and light will change the SKU, just like the gun ID
					var optic = selections.data.details.optic !== null ? selections.data.details.optic : '';
					var light = selections.data.details.light !== null ? selections.data.details.light : '';
					endpoint += '?optic=' + optic + '&light=' + light;
				} else if (selections.data.partNumber !== null) {
					// if you've searched by partnumber, optics and light are baked into the results
					endpoint += '?partNumber=' + selections.data.partNumber;
				}
			}
		}
		return endpoint;
	}

	function loadDynamicVariantData() {
		$.ajax({
			url: getApiEndpoint(),
			success: function (response, textStatus, jqXHR) {

				// clean the slate
				$('#dynamic-options').html('');
				$('#dynamic-options-select').html('');
				dynamicConfigurations = [];

				dynamicOptions = response.data.attributes;
				dynamicVariants = response.data.holsters;

				// empty results happen when:
				// -- you've been through the finder and are viewing an incompatible holster
				// -- some other handle error
				if (!Object.keys(dynamicOptions).length && !dynamicVariants.length) {
					$('#product-form').addClass('disabled');
					return;
				}

				let groups = {};
				let configurations = [];
				let i = 0;
				// build option groups
				for (let [optionKey, optionName] of Object.entries(dynamicOptions)) {
					let displayOptionName = optionName;
					let ui = (optionName === 'Color' || optionName === 'Size') ? 'button' : 'select';
					$('#dynamic-options').append(getGroupMarkup(displayOptionName, ui, i, optionKey));
					groups[optionKey] = [];
					i++;
				}

				// populate option groups
				let optionData = {};
				let hasQuickShipVariant = false;
				for (let c = 0; c < dynamicVariants.length; c++) {
					let combinedValues = [];
					// loop through the options we care about
					for (let [optionKey, optionName] of Object.entries(dynamicOptions)) {
						// get the value of that option for this product
						let value = dynamicVariants[c][optionKey];
						// edge case when the value is null
						if (!value) {
							continue;
						}
						let handle = window.helpers.makeHandle(value);
						// if we haven't already added this value to this option group, add it
						if (!groups[optionKey].includes(value)) {
							if (!optionData[optionKey]) {
								optionData[optionKey] = {
									key: optionKey,
									name: optionName,
									values: []
								};
							}
							optionData[optionKey].values.push({
								value: value,
								handle: handle
							});
							// add this value to the groups so it doesn't get added again
							groups[optionKey].push(value);
						}
						// build up this configuration
						combinedValues.push(handle);
					}

					let configurationStr = combinedValues.join(delimiter);
					if (!configurations.includes(configurationStr)) {
						dynamicConfigurations.push({
							"configuration": configurationStr,
							"price": Math.round(dynamicVariants[c]['price'] * 100),
							"id": dynamicVariants[c]['product_id']
						})
						configurations.push(configurationStr);
					}
					possibleConfigurations = configurations;

					// let _allowed = dynamicVariants[c]['allowed_shopify_add_on_variant_ids'].split(',');
					// _allowed = _allowed.map(a => {
					//   // Make sure our list only includes trimmed strings
					//   return (a === null) ? '' : (a+'').trim();
					// }).filter(a => {
					//   // Make sure our list doesn't include any empty strings
					//   return (a !== '');
					// });
					// allowedAddOnVariantIds[dynamicVariants[c]['product_id']] = (_allowed.length) ? _allowed : null;

					if (dynamicVariants[c]['quick_ship'] === 1) {
						hasQuickShipVariant = true;
					}
				}

				// show the badge if any variant is quick ship
				$('.quick-ship-badge').hide();
				if (hasQuickShipVariant) {
					$('.quick-ship-badge').show();
				}

				// Now populate the DOM elements
				i = 0;
				for (let [_optionKey, _optionData] of Object.entries(optionData)) {

					let optionKey = _optionData.key;
					let optionName = _optionData.name;

					_optionData.values.forEach(valueObj => {

						let value = valueObj.value;
						let displayValue = value;
						let handle = valueObj.handle;

						// insert the UI element
						let mkImg = '';
						let classes = 'swatch';
						let $group = $('[data-option-handle="' + optionKey + '"]');
						if (optionName === 'Color') {
							mkImg = ` style="background-image: url(${window.routes.asset_cdn_url}swatch-${handle}.png?v=2)" title="${value}" data-toggle="tooltip"`;
							classes += ' is-color';
						}
						if (optionName === 'Color' || optionName === 'Size') {
							$(getSwatchMarkup(classes, value, handle, i, mkImg)).insertAfter($group.find('label'));
						}

						// add it to the select
						let disabled = i === 0 ? '' : 'disabled';
						$('#option-' + i).append(`<option value="${handle}" ${disabled}>${displayValue}</option>`);

					});

					i++;
				}

				autoSelectDynamicVariants(groups, dynamicVariants);

				$b.trigger('data-ready');
			}
		});
	};

	function autoSelectDynamicVariants(groups, dynamicVariants) {
		if (window.useDynamicVariants && partNumber) {
			var keys = Object.keys(groups);
			// enable checkout and bypass the finder when we have a part number
			// this assumes the user knows what they're doing and don't need to verify fit with their gun
			$.ajax({
				method: 'POST',
				url: window.apiHost + '/holsters/search',
				data: {
					partNumber: partNumber
				},
				success: function (result, status, xhr) {
					if (result.data.length) {
						// we have a match, select the options
						keys.forEach(key => {
							selectOption($(`[data-option-handle="${key}"]`), result.data[0][key]);
						});
					} else {
						// didn't find a match (unlikely), try to select anyway
						for (let index = 0; index < dynamicVariants.length; index++) {
							const element = dynamicVariants[index];
							if (element.legacy_part_number == partNumber) {
								keys.forEach(key => {
									selectOption($(`[data-option-handle="${key}"]`), element[key]);
								});
								break;
							}
						}
					}
				},
				error: function (xhr, status, error) {
					console.log(status, error);
				}
			});
		} else if (window.useDynamicVariants) {
			let $firstSwatch = $('[data-option-index="0"] .swatch').first();
			if ($firstSwatch.length) {
				$firstSwatch.addClass('selected');
				$('#option-0').val($firstSwatch.data('value'));
			}
		}
	};

	$b.on('change', inputSelector, function () {
		let $group = $(this).closest('.product-option');
		let $remainingGroups = $group.nextAll('.product-option');
		if (!$(this).val()) {
			disablePurchase();
			return;
		}
		if ($remainingGroups.length) {
			enableOptions($remainingGroups);
		} else {
			enablePurchase();
		}
	});

	// set inital state once options are ready
	$b.on('data-ready', function () {

		let $firstGroup = $('.product-option[data-option-index="0"]');

		// use dynamic configurations rather than what shopify outputs from variants
		if (window.useDynamicVariants) {
			$allOptions = $('#dynamic-options-select').find('option');
			disablePurchase();
		}

		// trigger a change on the first input on page load to set up the next group
		$firstGroup.find(inputSelector).trigger('change');

		// auto-select the first group if there's only one color (uncommon)
		// this can happen when you're on a holster after going through the finder
		// and your firearm reduces the color options down to a single choice.
		// var $colors = $firstGroup.find('.swatch');
		// if ($colors.length === 1) {
		//   $colors.first().click(); // first() is unnecessary here but it reads better
		// }

		// enable tooltips
		$('[data-toggle="tooltip"]').tooltip();

	});

	/*
	Build options for dynamic price-based variants
	*/
	if (!window.useDynamicVariants) {
		// no ajax-y business to do, ready to go
		$b.trigger('data-ready');
	} else {
		loadDynamicVariantData();
	}

	$b.on('data-reload', function () {
		loadDynamicVariantData();
	});

	$b.on('click', '.swatch', function (e) {
		e.preventDefault();
		$(this).closest('.form-group').find('.swatch').removeClass('selected');
		$(this).addClass('selected').blur(); // blur to kill the tooltip
		// set the value of the hidden select
		$($(this).data('for')).val($(this).data('value')).trigger('change');
		// update gallery
		if ($(this).hasClass('is-color')) {
			let cleanedValue = window.helpers.makeHandle($(this).data('value'));
			let $mediaThumb = $(`#product-thumbs .thumb[data-for-color="${cleanedValue}"]`).first();
			if ($mediaThumb.length && !$mediaThumb.closest('li').hasClass('active')) {
				$mediaThumb.click();
			}
		}
	});

}

/*
Element order updates
*/
const pdpResponsiveUpdates = window.helpers.debounce(function () {
	let $media = $('#product-media-items');
	if ($w.width() < window.vars.breakpoints.lg) {
		$media.on('afterChange', function (event, slick, currentSlide) {
			$('#product-thumbs li').removeClass('active');
			let $el = $(`#product-thumbs [data-index="${currentSlide}"]`);
			$el.addClass('active');
			$(`#product-thumbs ul`).scrollLeft($el.outerWidth() * currentSlide);
		});
		$media.slick({
			infinite: true,
			slidesToShow: 1,
			arrows: true,
			dots: false,
			touchMove: false,
			swipe: false,
			prevArrow: `<button type="button" class="slick-prev"><span class="visually-hidden">Previous</span>${window.iconStrings.previousControl}</button>`,
			nextArrow: `<button type="button" class="slick-next"><span class="visually-hidden">Next</span>${window.iconStrings.nextControl}</button>`
		});
	} else {
		if ($media.hasClass('slick-initialized')) {
			$media.slick('unslick');
		}
	}
}, 250);
pdpResponsiveUpdates();
window.addEventListener("resize", pdpResponsiveUpdates);

/*
 Size helper
*/
var setSizeValue = function (size) {
	$(`[data-option-index="${$('#size-helper').data('for')}"] .product-form-input`).val(`Group ${size}`).trigger('change');
	$('#size-result').text(size);
}

if ($('#size-helper').length && window.sizeDatasetKey !== '') {
	let sizeDataset = JSON.parse($('#size-helper-data').text());
	let keys = Object.keys(sizeDataset);
	var helperObj = null;

	keys.forEach(key => {
		let groupKeys = key.split('|');
		groupKeys.forEach(groupKey => {
			if (groupKey === window.sizeDatasetKey) {
				helperObj = sizeDataset[key];
			}
		});
	});

	if (helperObj) {
		// helper markup
		let baseHtml = `<button class="toggle">Find your size<span>${window.iconStrings.caret}</span></button>
    <div class="body">
    <table class="compressed">
      <thead>
        <tr><th width="10%" class="col-center">Size</th></tr>
      </head>
      <tbody>
        <tr><td id="size-result" class="col-center"></td></tr>
      </tbody>
    </table>
    </div>`;
		$('#size-helper').html(baseHtml);

		// build the table
		let $table = $('#size-helper .compressed');
		let headings = helperObj.columns.split('|');
		for (let i = headings.length - 1; i >= 0; i--) {
			$table.find('thead tr').prepend('<th>' + headings[i] + '</th>');
			$table.find('tbody tr').prepend(`<td><label for="pouch-selection-${i}" class="visually-hidden">Select ${headings[i]}</label><select id="pouch-selection-${i}" class="is-style-small"><option value="">Select...</option></select></td>`);
		}

		// populate first select
		let $primarySelection = $('#pouch-selection-0');
		let $secondarySelection = $('#pouch-selection-1');
		let secondarySelectionBase = $secondarySelection.html();
		let options = Object.keys(helperObj.data);

		options.forEach(name => {
			// if there's only one choice, use the value for the key, otherwise use the key as the option's value
			let value = helperObj.data[name];
			if ($secondarySelection.length) {
				value = name;
			}
			$primarySelection.append('<option value="' + value + '">' + name + '</option>');
		});

		// show it
		$('#size-helper').show();

		// primary select changes
		$primarySelection.on('change', function () {
			let value = $(this).val();
			if ($secondarySelection.length) {
				let options = helperObj.data[value];
				let secondaryValues = Object.keys(options);
				let secondarySelectionHtml = secondarySelectionBase; // reset to inital empty selection when on primary changes
				secondaryValues.forEach(value => {
					secondarySelectionHtml += '<option value="' + options[value] + '">' + value + '</option>';
				});
				$secondarySelection.html(secondarySelectionHtml);
			} else {
				setSizeValue($(this).val());
			}
		});

		// secondary select changes
		$secondarySelection.on('change', function () {
			setSizeValue($(this).val());
		});
	}
}


/*
  Navigate the media gallery
*/
$('#product-thumbs a').on('click', function (e) {
	e.preventDefault();
	let targetIndex = $(this).closest('li').data('index');
	if ($('#product-media-items').hasClass('slick-initialized')) {
		$('#product-media-items').slick('slickGoTo', targetIndex);
		$('#product-thumbs li').removeClass('active');
		$(this).closest('li').addClass('active');
	}
});

/*
  Image Zoom
*/
$('.zoom').each(function () {
	$(this).zoom({
		url: $(this).data('src'),
		on: 'click',
		onZoomIn: function () {
			$(this).closest('.zoom').addClass('is-zoomed');
		},
		onZoomOut: function () {
			$(this).closest('.zoom').removeClass('is-zoomed');
		}
	});
});

$('#product-form form button[type=submit]').on('click', function (e) {
	// Set add to cart timestamp
	var addedToCartTimestamp = (new Date()).toISOString();
	$(e.target).closest('form').find('#itemprop-added-to-cart-timestamp').val(addedToCartTimestamp);
});
